export function isValidStringInput(input: string | undefined) {
  if (!input) {
    return false; // Empty or undefined input
  }
  // Check for script injection
  const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  if (scriptRegex.test(input)) {
    return false; // Contains script tag
  }

  // Check for SQL injection
  const sqlKeywords = [
    'select',
    'insert',
    'update',
    'delete',
    'drop',
    'create',
    'alter',
  ];
  for (const keyword of sqlKeywords) {
    const regex = new RegExp('\\b' + keyword + '\\b', 'i');
    if (regex.test(input)) {
      return false; // Contains SQL keyword
    }
  }

  // Input passed all checks
  return true;
}

export function isValidEmail(input:string | undefined) {
  if (!input) {
    return false;
  }
  // Regular expression for basic email validation
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(input);
};


export function isValidPhoneNumber(input:string) {
  const numberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  if(numberRegex.test(input)){
    return true;
  }
}